import { createSelector } from 'reselect'

const selectNullOrders = store => store.tse.nullOrders

export const selectHasYearOrder = createSelector(
	selectNullOrders,
	nullOrders => {
		return nullOrders?.some(order => order.type === 'YEAR_ORDER' &&
			typeof order?.printed === 'boolean' && order?.printed === false)
	}
)
